import Barba from 'barba.js';

// import gsap from 'gsap';

// import components
import Component from '../base/component';
import Menu from '../components/menu';
import Colophon from '../components/colophon';
import ContactOverlay from '../components/contact-overlay';
import ParallaxScroll from '../components/parallax-scroll';
import Shapes from '../components/shapes';
import Loader from '../components/loader';
import ScrollIco from '../components/scroll-ico';

// import containers
import Homepage from './Homepage';
import Services from './Services';
import About from './About';
import Cases from './Cases';
import Contact from './Contact';
import News from './News';
import People from './People';
import Single from './Single';
import Privacy from './Privacy';
import Base from './Base';

//utils
import { qs, qsa, byId, toggleClass } from '../base/dom-utils';
import Common from '../base/common';

class App extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.toggleMenuState = this.toggleMenuState.bind(this);
        this.toggleContactState = this.toggleContactState.bind(this);
        this.resetNewPage = this.resetNewPage.bind(this);

        this._scrollY = 0;

        const mapNsToComponent = this._componentMap = new Map();

        mapNsToComponent.set('homepage', Homepage);
        mapNsToComponent.set('about', About);
        mapNsToComponent.set('cases', Cases);
        mapNsToComponent.set('contact', Contact);
        mapNsToComponent.set('news', News);
        mapNsToComponent.set('people', People);
        mapNsToComponent.set('services', Services);
        mapNsToComponent.set('single', Single);
        mapNsToComponent.set('privacy', Privacy);

        this.$els.body = document.body;

        this.$els.menuOpen = qs(this.options.menuOpen);
        this.$els.menuClose = qs(this.options.menuClose);
        this.$els.contactTrigger = qs(this.options.contactTrigger);
        this.$els.siteContact = qs(this.options.siteContact);
        this.$els.contactClose = qs(this.options.contactClose, this.$els.siteContact);
        this.$els.scrollIco = byId(this.options.scrollIco);

        this.setRef('menu', Menu, this.options.siteNavigation);
        this.setRef('contactOverlay', ContactOverlay, this.options.siteContact);
        this.setRef('colophon', Colophon, this.options.colophon);
    }

    beforeInit() {

        Barba.Dispatcher.on('transitionCompleted', (currentStatus, oldStatus) => {

            const oldNamespace = oldStatus ? oldStatus.namespace : '';
            const currNamespace = currentStatus.namespace;
            const currPage = this._componentMap.get(currNamespace) ? this._componentMap.get(currNamespace) : Base;

            // console.log('from: ' + oldNamespace + ' to: ' + currNamespace);

            // if we set refs of a previous page, close it
            if (oldNamespace) {
                this.$refs[oldNamespace].destroy();
            }

            // set new page ref and attach scroll events
            this.setRef(currNamespace, currPage, '.barba-container').then(() => {
                const scrollbarInstance = this.$refs[currNamespace]._scrollbar;
                this.attachScroll(currNamespace, scrollbarInstance);
            });

            // if we are on first entering, trigger animationIn
            if (!oldNamespace) {
                new Loader('#site-loader').init().then(() => {
                    this.$refs[currNamespace].animationIn();
                    const scrollbarInstance = this.$refs[currNamespace]._scrollbar;
                    this.attachScroll(currNamespace, scrollbarInstance);
                });
            }

        });

        Barba.Dispatcher.on('pageEnteredCompletely', (currNamespace) => {
            this.$refs[currNamespace].animationIn();
        });


        Barba.Dispatcher.on('newPageReset', this.resetNewPage);

        this.delegate('click', this.options.menuOpen, this.toggleMenuState);
        this.delegate('click', this.options.menuClose, this.toggleMenuState);
        this.delegate('click', this.options.contactTrigger, this.toggleContactState);
        this.delegate('click', this.options.contactClose, this.toggleContactState);
        this.delegate('click', this.options.colophonTrigger, this.toggleColophonState);

        this.delegate('click', this.options.siteNavigation, (e) => {
            const { menuWrap } = this.$refs.menu.$els;
            if (this.getState('isMenuOpen') === false) {
                return;
            }
            if (menuWrap === e.target || menuWrap.contains(e.target)) {
                return;
            }
            this.setState('isMenuOpen', false);
            this.$refs.menu.setState('isMenuOpen', false);

        });

        this.onColophonClickOutside = function onColophonClickOutside(e) {
            const $el = this.$refs.colophon.$el;
            if ($el === e.target || $el.contains(e.target)) {
                return;
            }
            this.setState('isColophonOpen', false);
            this.$refs.colophon.setState('isColophonOpen', false);
        }.bind(this);

        this.on('change:isColophonOpen', (isColophonOpen) => {
            if (isColophonOpen) {
                setTimeout(() => {
                    document.body.addEventListener('click', this.onColophonClickOutside, false);
                }, 100);
            } else {
                document.body.removeEventListener('click', this.onColophonClickOutside, false);
            }
        });



        const modalToggle = function modalToggle(isOpen) {
            if (isOpen) {

                this._scrollY = window.scrollY || window.pageYOffset;
                document.body.style.top = -(this._scrollY) + 'px';

                toggleClass(this.$els.body, 'is-modal-open', isOpen);

            } else {

                toggleClass(this.$els.body, 'is-modal-open', isOpen);

                window.scrollTo(0, this._scrollY);
            }
        }.bind(this);

        this.on('change:isMenuOpen', modalToggle);

        this.on('change:isContactOpen', modalToggle);

        this.on('change:isColophonOpen', (isOpen) => {

            if (isOpen) {

                this._scrollY = window.scrollY || window.pageYOffset;
                document.body.style.top = -(this._scrollY) + 'px';

                toggleClass(this.$els.body, 'is-colophon-open', isOpen);
                // toggleClass(this.$els.body, 'is-modal-open', isOpen);

            } else {

                toggleClass(this.$els.body, 'is-colophon-open', isOpen);
                // toggleClass(this.$els.body, 'is-modal-open', isOpen);

                window.scrollTo(0, this._scrollY);
            }

        });

    }

    attachScroll(container, scrollbarInstance) {

        if (scrollbarInstance) {

            if ( !Modernizr.touchevents || Common.mq('desktop') ) {

                const els = qsa(this.options.parallaxElements);

                els.forEach((el, key) => this.$refs[container].setRef(key + '::parallax-scroll', ParallaxScroll, el, {
                    scrollbarInstance
                }));

                this.setRef('shapes', Shapes, this.options.shapes, {
                    scrollbarInstance
                });

            }

            this.setRef('scrollico', ScrollIco, this.options.scrollIco, {
                scrollbarInstance
            });

        }

    }

    toggleMenuState(e) {
        e.preventDefault();

        const currentMenuState = this.getState('isMenuOpen');

        this.setState('isMenuOpen', !currentMenuState);
        this.$refs.menu.setState('isMenuOpen', !currentMenuState);

        this.setState('isContactOpen', false);
        this.$refs.contactOverlay.setState('isContactOpen', false);
        this.setState('isColophonOpen', false);
        this.$refs.colophon.setState('isColophonOpen', false);
    }

    toggleContactState(e) {
        e.preventDefault();

        const currentContactState = this.getState('isContactOpen');

        this.setState('isContactOpen', !currentContactState);
        this.$refs.contactOverlay.setState('isContactOpen', !currentContactState);

        this.setState('isMenuOpen', false);
        this.$refs.menu.setState('isMenuOpen', false);
        this.setState('isColophonOpen', false);
        this.$refs.colophon.setState('isColophonOpen', false);
    }

    toggleColophonState(e) {
        e.preventDefault();

        const currentColophonState = this.getState('isColophonOpen');

        this.setState('isColophonOpen', !currentColophonState);
        this.$refs.colophon.setState('isColophonOpen', !currentColophonState);

        this.setState('isContactOpen', false);
        this.$refs.contactOverlay.setState('isContactOpen', false);
        this.setState('isMenuOpen', false);
        this.$refs.menu.setState('isMenuOpen', false);
    }

    resetNewPage() {

        this.setState('isMenuOpen', false);
        this.setState('isContactOpen', false);
        this.setState('isColophonOpen', false);
        this.$refs.menu.setState('isMenuOpen', false);
        this.$refs.contactOverlay.setState('isContactOpen', false);
        this.$refs.colophon.setState('isColophonOpen', false);

        window.scrollTo(0, 0);
    }

    getDefaultOptions() {
        return {
            siteNavigation: '#site-navigation',
            siteContact: '#site-contact',
            colophon: '#colophon',
            menuOpen: '#header-burger',
            menuClose: '#header-bolt',
            contactTrigger: '#contact-trigger',
            colophonTrigger: '#colophon-trigger',
            shapes: '#shapes-canvas',
            contactClose: '.c-contact__close',
            scrollIco: '#scroll-down',
            parallaxElements: '[data-speed]'
        };
    }

    getInitialState() {
        return {
            isMenuOpen: false,
            isContactOpen: false,
            isColophonOpen: false
        };
    }
}

export default App;


/** WEBPACK FOOTER **
 ** ./containers/App.js
 **/